import { TextFieldRoot, TextFieldLabel, TextField } from "@/components/shadcn/textfield";
import { TextArea } from "@/components/shadcn/textarea";

export function TextAreaInput(props) {

  const onInput = (ev) => {
    props?.input(props.name, ev.target.value);
  }

  const onKeyUp = (ev) => {
    if (props.keyaction) {
      props?.keyaction(ev);
    }
  }

  const onKeyDown = (ev) => {
    if (props.submitOnEnter && ev.key === 'Enter') {
      props?.submit();
    }
  }

  return (
    <TextFieldRoot name={props.name} class="space-y-0">
      <TextFieldLabel class={props.sr ? 'sr-only mb-1' : ''}>{props.label}</TextFieldLabel>
      <TextArea
        class="mt-[0px]"
        placeholder={props.placeholder ?? ''}
        type={props.type ?? 'text'}
        autoCapitalize="none"
        autocorrect="off"
        disabled={props.loading}
        value={props.form[props.name]}
        onChange={onInput}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        readOnly={props.readOnly}
        rows={props.rows ?? 4}
      />
    </TextFieldRoot>
  );
}
